// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__DWsiJ","signatureButtonsRight":"ModalSign_signatureButtonsRight__3oy6M"};